import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ExportCreator.css";
import MultiSelectDropdown from "../../common/utils/MultiSelectDropdown";
import { formatFullDate } from "../../common/utils/helperFunctions";
import { exportOrder } from "../../services/exports.service";
import { resetSelectedFeature } from "../../slices/searchSlice";
import * as orderActions from "../../slices/orderSlice";
import * as mapActions from "../../slices/mapSlice";
import { Dropdown } from "react-bootstrap";
import SingleSelectDropdown from "../../common/utils/SingleSelectDropdown";
import Close from "../../assets/images/svgs/Close.svg?react"

const ExportCreator = () => {

    const workspaceID = '272c97f6-8215-4071-8dab-f26b4ae2b9f6';

    const dispatch = useDispatch();

    const selectedFeature = useSelector(state => state.search.selectedFeature);
    const isLeftNavCollapsed = useSelector(state => state.leftNav.isCollapsed);
    const storageLocation = useSelector(state => state.providerDetails.storageEndpoints);

    const [selectedOptions, setSelectedOptions] = useState([]);

    const [exportsData, setExportsData] = useState({
        storageLocation: null,
    });

    const disableExportButton = () => {
        return selectedOptions.length === 0 ||
            exportsData.storageLocation === null
    };

    const getAssetsWithHref = () => {
        const filteredAssets = Object.entries(selectedFeature.assets)
            .filter(([_, value]) => value.href) // Filter assets where href is not empty
            .map(([key, value]) => ({ key, value: { ...value, href: value.href } })); // Keep full value
        return filteredAssets;
    };

    // const passSortedAssets = () => {
    //     const sortedAssets = Object.fromEntries(
    //         Object.entries(selectedFeature.assets).sort((a, b) => {
    //             return a[1].href ? -1 : b[1].href ? 1 : 0;
    //         })
    //     );
    //     const sortedAssetsArray = Object.entries(sortedAssets).map(
    //         ([key, value]) => ({ key, value })
    //     );
    //     return sortedAssetsArray;
    // };

    const onSelectItemChange = (selectedValue, fieldName) => {
        setExportsData((prevData) => ({
            ...prevData,
            [fieldName]: selectedValue,
        }));
    };

    const handleSelectionChange = (selectedItems) => {
        setSelectedOptions(selectedItems);
    };

    const showImageInformation = () => {
        return (
            <>
                <div className="row image-info">
                    <div className="col">
                        <div className="info-label">Date & Time</div>
                        <div className="info-value">{formatFullDate(selectedFeature.properties['datetime'])}</div>
                    </div>
                    <div className="col image-info-col">
                        <div className="info-label">Cloud Cover</div>
                        <div className="info-value">{selectedFeature.properties['eo:cloud_cover'] || selectedFeature.properties['cloudCover']}</div>
                    </div>
                </div>
                <div className="row image-info">
                    <div className="col">
                        <div className="info-label">Item ID</div>
                        <div className="info-value">{selectedFeature['id']}</div>
                    </div>
                </div>
            </>
        )
    }

    const navigateToMainPage = () => {
        dispatch(resetSelectedFeature());
        dispatch(orderActions.resetAllCollections());
        dispatch(mapActions.resetSearchedAoi());
        dispatch(mapActions.resetDisplayView());
        dispatch(mapActions.resetExportsView());
        dispatch(mapActions.resetCoordinatesGeometry());
    };

    const backToSearchResults = () => {
        dispatch(mapActions.setSearchView());
        dispatch(mapActions.resetExportsView());
    }

    const exportOrderSuccessCallback = () => {
        navigateToMainPage();
        dispatch(orderActions.setSuccessMessage("Export Request Placed Successfully"));
        setTimeout(() => dispatch(orderActions.resetSuccessMessage()), 5000);
    };

    const exportImage = () => {

        // const selectedWithHref = selectedOptions
        //     .filter(option => option.value.href)
        //     .map(option => option.key);

        // const selectedWithoutHref = selectedOptions
        //     .filter(option => !option.value.href)
        //     .map(option => option.key);

        const exportParams = {
            workspaceID,
            itemPackageFormat: 'none',
            assets: selectedOptions.map(item => item.key),
            items: [selectedFeature.id],
            collectionID: selectedFeature.collection,
            storageEndpointID: exportsData.storageLocation,
            // asset: {
            //     types: (selectedWithHref && selectedWithHref.length > 0) ? selectedWithHref : [],
            // },
            // orderAsset: {
            //     types: (selectedWithoutHref && selectedWithoutHref.length > 0) ? selectedWithoutHref : [],
            // },
        };
        dispatch(exportOrder(exportParams, exportOrderSuccessCallback));
    };

    return (
        <>
            <div className={`orderDescriptionBox exportCreatorDescriptionBox ${isLeftNavCollapsed ? 'collapsed' : ''}`}>
                <div className="orderDeliveryPage">
                    <div className="exportCreatorTitle">
                        <div className="exportCreatorTitleText">Data Download</div>
                        <div className="extra-info">
                            <button
                                className="icon-button"
                                onClick={() => navigateToMainPage()}
                            >
                                <Close />
                            </button>
                        </div>
                    </div>

                    <div className="imageInfoSection">
                        {showImageInformation()}
                    </div>

                    <div className="imageInfoSection bottomBorder">
                        <div className="image-title">
                            <div className="image-title-text">Download Configuration</div>
                        </div>
                        <div className="summaryContent">
                            <span>Delivery Location</span>
                            <SingleSelectDropdown
                                options={storageLocation}
                                onSelectItemChange={onSelectItemChange}
                                keyName="storageEndpointID"
                                valueName="name"
                                selectedValue={exportsData.storageLocation}
                                dropdownName="storageLocation"
                                placeholder="Select a location"
                            />
                        </div>
                        <div className="image-info summaryContent">
                            <div>Item Assets</div>
                            <div className="info-value">
                                <MultiSelectDropdown
                                    options={getAssetsWithHref()}
                                    onSelectionChange={handleSelectionChange}
                                    dropdownName="assets"
                                    placeholder="Select assets"
                                    itemLabel="asset"
                                    keyName='key'
                                    valueName="value.title"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="downloaOrderSection">
                        <button
                            className="cancel-order-btn modalFooterCloseBtn"
                            onClick={() =>
                                backToSearchResults()
                            }
                        >
                            Back
                        </button>
                        <button
                            className={disableExportButton() ?
                                "export-order-btn modalFooterApplyBtn disabledBtn" :
                                "export-order-btn modalFooterApplyBtn"}
                            disabled={disableExportButton()}
                            onClick={() => exportImage()}
                        >
                            Download
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExportCreator;
